import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Guidelines from 'routes/Products/components/Guidelines';

import {Col, Container, Row, Progress} from 'reactstrap';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';
import ProductsOnboard from 'routes/Products/containers/ProductsOnboard';
import Video from 'routes/Products/components/Video';
import {connect} from 'react-redux';
import {actions} from 'modules/user';
import ReactJoyride, {ACTIONS, EVENTS, STATUS} from 'react-joyride';
import getContent from 'lib/getContent';
import weeksListDepth1 from './data/weeksListDepth1.json';
import DashboardCard from './DashboardCard';

@connect(
  state => ({authToken: state.user.authToken}),
  {
    refreshToken: actions.refreshToken,
    getUserData: actions.getUserData,
    post: actions.postUserData
  }
)
class Dashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      canShowOnbaord: false,
      runTour: true
    };

    const path = location.pathname.split('/');
    this.ProductInPath = path[2];

    //legacy onboard todo take out
    // const filteredContentItems = this.props.Children
    //   //First get the list of onboard items - originally wlc and lifestyle
    //   .filter(contentItem => contentItem.type === 'onboardList');
    // The sort makes sure wlc onboard goes first

    // const onboardList = filteredContentItems[0]
    //   ? filteredContentItems[0].Children.sort(a => a.slug !== 'wlc-onboard')
    //   : [];

    // // const sortedOnboardList = onboardList.sort((a, b) => a.data.order - b.data.order);
    // this.onboardList = onboardList || [];

    // //TODO how to track this in UserData?

    // this.onBoardVideo = this.onboardList[0].Children.find(item => item.type === 'video');

    // //No items are active
    // this.onboardList.map((onboardItem, i) => {
    //   onboardItem.active = false;
    //   onboardItem.queuePosition = i; // same as index value in the array, for convenience below
    // });
    this.path = location.pathname.split('/');
    this.productSlug = this.path[2];
    this.getCurrentWeek = this.getCurrentWeek.bind(this);
    this.getCurrentActionHour = this.getCurrentActionHour.bind(this);
    this.getOnboard = this.getOnboard.bind(this);

    this.tourSteps = [
      {
        target: 'body',
        placement: 'center',
        title: 'Welcome to your WLC dashboard',
        content: 'Welcome to the WLC dashboard.  This is your home base when navigating through the Club.'
      },
      {
        target: '.orientation-status',
        placement: 'auto',
        title: 'Orientation Progress',
        content:
          'This is your progress towards your WLC orientation. Click on it to finish the next item on your list. '
      },
      {
        target: '.productSideBarContainer',
        placement: 'auto',
        title: 'Navigation Bar',
        content: 'Use this section to move around the WLC community. '
      },
      {
        target: '.headerUserInfoV2ProductContainer',
        placement: 'auto',
        title: 'My Products',
        content: 'Click here to see all your Food Revolution Network products.'
      }
    ];
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    //get WeeksList, depth=2, this is just getting the latest week //todo should we have a query param for this instead?
    this.getCurrentWeek();
    this.getCurrentActionHour();
    this.getOnboard();
  }
  //JOYRIDE Stuff
  handleJoyrideCallback = data => {
    const {status, type} = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      this.setState({runTour: false});
      this.props.updateTourStatus('dashboard', true);
    }
  };

  //get the current weekly guide by getting the weekslist depth=2 and return the last one
  getCurrentWeek() {
    const {weeksListSlug} = this.props;

    getContent(weeksListSlug, this.productSlug, this.props.authToken, '?depth=2')
      .then(res => {
        const allWeeksList = res.Children; //for clarity
        this.setState({currentWeek: allWeeksList[allWeeksList.length - 1]}); //api is 1 week ahead, so -2
      })
      .catch(e => {
        console.log('error getting weeklist list');
      });
  }
  //action-hours
  getCurrentActionHour() {
    const {actionHoursId} = this.props;
    getContent(actionHoursId, this.productSlug, this.props.authToken, '?depth=2')
      .then(res => {
        const allActionHours = res.Children; //for clarity
        this.setState({currentActionHour: allActionHours[0]});
      })
      .catch(e => {
        console.log('error getting Actions Hours list');
      });
  }
  getOnboard() {
    const {onBoardContentId} = this.props;

    getContent(onBoardContentId, this.productSlug, this.props.authToken)
      .then(res => {
        //need onboard video
        //onboarding checklist
        const checklistOnboard = res.Children.find(item => item.type === 'checklist');
        const onboardVideo = res.Children.find(item => item.type === 'video');
        this.setState({checklistOnboard, onboardVideo});
        console.log('checklistOnboard ', checklistOnboard);
        this.getChecklistResponses(checklistOnboard.id);
      })
      .catch(e => {
        console.log('error getting onboard list', e.message);
      });
  }

  //Getting USER DATA for the checklist, this.id = id for checklist
  //This is used to determine the progress of the onboard.  we get the checklist userdata and determin how many items have been done
  async getChecklistResponses(onboardID) {
    const savedData = await this.props.getUserData(onboardID);
    console.log('saved checklist responses, id  ', onboardID, savedData);
    if (savedData && savedData.start && savedData.start.values) {
      this.calculatePercentageCompleted(savedData.start.values);
    }
  }

  //received an OBJECT of items from saved state on mount
  calculatePercentageCompleted = items => {
    const totalItems = Object.keys(items).length;
    let finished = 0;
    for (let property in items) {
      items[property] ? finished++ : null;
    }
    console.log('finished ', finished);
    this.setState({progress: Math.round((finished / totalItems) * 100)});
  };

  handleNav = slug => {
    console.log('slug ', slug);
    if (slug) this.props.history.push(`/products/${this.productSlug}/${slug}`);
  };

  render() {
    const {currentActionHour, currentWeek, onboardVideo} = this.state;
    const {toursCompleted, toursLoaded} = this.props;
    const showTour = !!toursLoaded && !toursCompleted.dashboard;

    return (
      <div>
        <Container className="py-5">
          <ReactJoyride
            continuous
            callback={this.handleJoyrideCallback}
            run={this.state.runTour && showTour}
            steps={this.tourSteps}
            scrollToFirstStep
            showProgress
            showSkipButton
            styles={{
              options: {
                zIndex: 10000
              }
            }}
          />
          <div className="pagetitle">
            <h1>WHOLE Life Club</h1>
          </div>
          <h4 className="pb-3">Welcome video</h4>
          <Row>
            <Col>
              {onboardVideo ? <Video key={onboardVideo.id} {...onboardVideo} /> : <Video key="loading-video" />}
            </Col>
          </Row>
          <Row
            className="orientation-status"
            onClick={() => this.handleNav('getting-started')}
            style={{cursor: 'pointer'}}
          >
            <Col xs="6">
              <h4 className="text-success m-0">Orientation progress</h4>
            </Col>
            <Col xs="6" className="text-center text-small">
              <Progress value={this.state.progress} color="success" style={{height: '30px'}}>
                {this.state.progress}% complete
              </Progress>
              <Link to={`/products/wlc/getting-started`}>
                {this.state.progress < 100 ? 'Continue' : 'Review'} Orientation
              </Link>
            </Col>
          </Row>
          <Row className="pt-3">
            <Col>
              <hr />
            </Col>
          </Row>
          <Row className="pt-5">
            <Col>
              <h4>Where would you like to go?</h4>
            </Col>
          </Row>
          <Row className="pt-4 pb-3">
            <Col xs="6" lg="3" className="py-3">
              {currentWeek ? (
                <DashboardCard {...currentWeek} handleNav={this.handleNav} />
              ) : (
                <DashboardCard type="week" handleNav={this.handleNav} />
              )}
            </Col>
            <Col xs="6" lg="3" className="py-3">
              <DashboardCard type="forum" slug="community" handleNav={this.handleNav} />
            </Col>
            <Col xs="6" lg="3" className="py-3">
              {currentActionHour ? (
                <DashboardCard {...currentActionHour} handleNav={this.handleNav} />
              ) : (
                <DashboardCard type="videoResource" handleNav={this.handleNav} />
              )}
            </Col>
            <Col xs="6" lg="3" className="py-3">
              <DashboardCard type="recipes" slug="recipes" handleNav={this.handleNav} />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

Dashboard.propTypes = {
  weeksList: PropTypes.shape({}).isRequired,
  actionHour: PropTypes.shape({}).isRequired
};

export default withRouter(Dashboard);
